import { render, staticRenderFns } from "./EmergencyLabel.vue?vue&type=template&id=166f0356&"
import script from "./EmergencyLabel.vue?vue&type=script&lang=js&"
export * from "./EmergencyLabel.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyLabel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports